import matchSorter from 'match-sorter'
import debouncePromise from 'debounce-promise'

const createCachedFetch = url => {
  let cache = null

  return () =>
    new Promise(resolve => {
      if (cache) {
        resolve(cache)
      } else {
        fetch(url)
          .then(res => res.json())
          .then(res => {
            cache = res
            resolve(cache)
          })
      }
    })
}

const cachedAirports = createCachedFetch(
  `${window.airportsPath}airports/short-8k.json`
)

const searchAirports = searchInput =>
  cachedAirports().then(res => {
    const options = res.map(airport => ({
      label: airport.name,
      value: `${airport.name} | ${airport.icao}`,
      airport,
    }))
    const matches = matchSorter(options, searchInput, {
      keys: [
        'airport.city',
        // 'airport.region',
        'airport.name',
        'airport.iata',
        'airport.icao',
        'airport.country',
      ],
      threshold: matchSorter.rankings.WORD_STARTS_WITH,
    })
    return matches.slice(0, 100)
  })

export default debouncePromise(searchAirports, 400)
